import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from '@ui/theme';
import React from 'react';

import useStyles from './StagingIncludes.style';

const MlsIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#D3E0E2', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <PhotoLibraryOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const SocialMediaIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#EDC687', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <FavoriteBorderOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const Zillow3DIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#E8E5F2', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <ThreeDRotationIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const DroneIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#FFCAB3', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <CloudQueueIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const VirtualStagingIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#DDD4C7', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <ViewInArIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const VideoIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#D3E0E2', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <VideocamOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const TwilightIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#EDC687', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <WbTwilightOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};


const stagingIncludes = [
  {
    icon: MlsIconWrapper,
    caption: 'MLS Photos'
  },
  {
    icon: SocialMediaIconWrapper,
    caption: 'Social Media Photos'
  },
  {
    icon: Zillow3DIconWrapper,
    caption: '3D Home Tours'
  },
  {
    icon: DroneIconWrapper,
    caption: 'Drone Photos & Video'
  },
  {
    icon: VirtualStagingIconWrapper,
    caption: 'Virtual Staging'
  },
  {
    icon: VideoIconWrapper,
    caption: 'Video'
  },
  {
    icon: TwilightIconWrapper,
    caption: 'Twilight Photos'
  },
];

const StagingIncludes: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: theme.spacing(2)
      }}
    >
      {stagingIncludes.map((si, i) => {
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              flex: '0 0 calc(35% - 20px)',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className={classes.root}
          >
            <si.icon />
            <Typography className={classes.caption}>
              {si.caption}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default StagingIncludes;
